import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col py-10 px-4 justify-center space-y-10" }
const _hoisted_2 = {
  key: 1,
  class: "animate-spin m-auto h-10 w-10 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_3 = {
  key: 0,
  class: "text-white font-medium"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, {
                slot: "start",
                class: "mr-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _ctx.goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("svg", {
                        class: "",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M6 11.9961H18",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M12 18L6 12L12 6",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { class: "h-full" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex flex-col w-full space-y-2" }, [
              _createElementVNode("div", { class: "flex text-white text-2xl font-medium" }, "Verify Image"),
              _createElementVNode("div", { class: "text-brand-light-gray text-lg" }, "Take a clear photo of yourself holding the ID Card that you submitted in the previous step.")
            ], -1)),
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.choosePhoto && _ctx.choosePhoto(...args))),
              class: "flex flex-col items-center space-y-4"
            }, [
              _createElementVNode("div", {
                style: _normalizeStyle([
                  !_ctx.isImageUrl ? `background-image: url('data:image/jpeg;base64,${_ctx.photo}')` : `background-image: url('${_ctx.photo}')`
              ]),
                class: _normalizeClass([{
              'border-2' : !_ctx.photo
            }, "flex w-full rounded-xl bg-cover bg-center border-brand-light-gray border-dashed h-56 px-24"])
              }, [
                (!_ctx.busy)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass([{ 'opacity-0' : _ctx.photo}, "text-brand-light-gray m-auto text-center text-sm"])
                    }, "Take a photo ", 2))
                  : _createCommentVNode("", true),
                (_ctx.busy)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }, null, -1),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ], 6),
              (_ctx.photo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Re-take photo"))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}